/**
 * Taleo Careers
 */
(function taleoCareers($) {
  function descriptionDialog(id) {}

  function filterJobs() {
    const location = $(`#job-location`).val();
    const category = $(`#job-category`).val();
    const search = $(`#job-search`).val();
    const $jobs = $(`[data-job]`);

    $jobs.show();

    // Locations
    if (location) {
      $("[data-location]")
        .filter((index, element) => {
          const jobLocation = $(element).data("location");
          return jobLocation !== location;
        })
        .hide();
    }

    // Categories
    if (category) {
      $("[data-category]")
        .filter((index, element) => {
          const jobCategory = $(element).data("category");
          return jobCategory !== category;
        })
        .hide();
    }

    // Search terms
    if (search) {
      $("[data-search-index]")
        .filter((index, element) => {
          const searchIndex = $(element).data("search-index");
          const pattern = new RegExp(search, "i");
          const match = searchIndex.match(pattern);
          return match === null;
        })
        .hide();
    }

    const jobCount = $("[data-job]:visible").length;

    // No results
    if (jobCount === 0) {
      $("[data-search-no-results]").show();
    } else {
      $("[data-search-no-results]").hide();
    }

    $(`[data-job-count]`).text(jobCount);
  }

  const $jobCount = $(`[data-job-count]`);
  if ($jobCount.length) {
    const jobCount = $("[data-job]:visible").length;
    $(`[data-job-count]`).text(jobCount);
  }

  const $jobLocation = $(`#job-location`);
  if ($jobLocation.length) {
    $jobLocation.on("change", filterJobs);
  }

  const $jobCategory = $(`#job-category`);
  if ($jobCategory.length) {
    $jobCategory.on("change", filterJobs);
  }

  const $jobSearch = $(`#job-search`);
  if ($jobSearch.length) {
    let timeout = null;

    $jobSearch.on("input", (event) => {
      const search = $(event.currentTarget).val();
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => {
        filterJobs();
      }, 500);
    });
  }

  // Job description dialogs
  function toggleJobDescription(jobId) {
    console.log(`jobId`, jobId);
    const jobDescription = $(`[data-job-description="${jobId}"]`);

    if (jobDescription.is(":visible")) {
      jobDescription.fadeOut(() => {
        $("body").removeClass("job-description-dialog-open");
      });
    } else {
      jobDescription.fadeIn();
      $("body").addClass("job-description-dialog-open");
    }
  }

  // Toggle open/close
  $(document.body).on("click", "[data-job]", (event) => {
    const jobId = $(event.currentTarget).data("job");
    toggleJobDescription(jobId);
  });

  // Close icon
  $(document.body).on("click", "[data-job-close]", (event) => {
    const jobId = $(event.currentTarget).data("job-close");
    toggleJobDescription(jobId);
  });

  // ESC keypress
  $(document).on("keyup", function (e) {
    if (e.key == "Escape") {
      const jobDescription = $(`[data-job-description]:visible`);
      if (jobDescription.length) {
        const jobId = jobDescription.data("job-description");
        toggleJobDescription(jobId);
      }
    }
  });

  // Click outside content closes
  $(document.body).on("click", "[data-job-description]", (event) => {
    if (!$(event.target).is("[data-job-description]")) return;

    const jobId = $(event.currentTarget).data("job-description");
    toggleJobDescription(jobId);
  });
})(window.jQuery);
